import del from './delete';
import get from './get';
import source from './source';
import put from './put';

export default { del, get, put, source };
